import styled from '@emotion/styled'
import { css } from '@emotion/react'

const contentStyles = ({ theme }) => css`
  label: content;

  padding-top: ${theme.spacings.tera};
  padding-bottom: ${theme.spacings.peta};
  border-bottom: 1px solid ${theme.colors.n200};

  ${theme.media.mega} {
    padding-top: ${theme.spacings.giga};
    padding-bottom: ${theme.spacings.giga};
    border: transparent;
  }
`

const pictureStyles = ({ theme }) => css`
  label: content__picture;

  position: relative;

  width: 95px;
  height: 95px;

  margin: 0 auto;
  margin-bottom: ${theme.spacings.giga};

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid ${theme.colors.n100};
  border-radius: ${theme.borderRadius.circle};
`

const imageStyles = ({ theme }) => css`
  label: content__image;

  display: block;

  width: 100%;
  height: 100%;

  border-radius: ${theme.borderRadius.circle};
`

const iconDollarStyles = ({ theme }) => css`
  label: content__icon-dollar;

  svg {
    color: ${theme.colors.v700};
    fill: ${theme.colors.v700};
  }
`

const iconStyles = ({ theme }) => css`
  label: content__icon;

  width: 100%;
  height: 100%;

  svg {
    display: block;

    width: 100%;
    height: 100%;

    padding: ${theme.spacings.mega};
    fill: ${theme.colors.n700};
  }
`

const symbolStyles = ({ theme }) => css`
  label: content__symbol;

  position: absolute;

  left: 0;
  bottom: 0;

  width: 28px;
  height: 28px;
  padding: 6px;

  display: flex;

  align-items: center;
  justify-content: center;

  color: ${theme.colors.n300};
  border-radius: ${theme.borderRadius.circle};

  background: ${theme.colors.white};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  transition: background ease-in 300ms;

  svg {
    width: 100%;
    display: block;
  }
`

const titleStyles = ({ theme }) => css`
  label: content__title;

  display: block;

  padding: 0 ${theme.spacings.tera};

  color: ${theme.colors.n800};
  font-size: ${theme.typography.text.giga.fontSize};
  line-height: ${theme.typography.text.giga.lineHeight};
  font-weight: ${theme.font.weight.semibold};

  text-align: center;
  word-break: break-word;

  ${theme.media.mega} {
    font-size: ${theme.typography.subHeadings.mega.fontSize};
    line-height: ${theme.typography.subHeadings.mega.lineHeight};
  }
`

const subTitleStyles = ({ theme }) => css`
  label: content__sub-title;

  padding: 0 ${theme.spacings.mega};

  color: ${theme.colors.n600};
  font-size: ${theme.typography.subHeadings.mega.fontSize};
  font-weight: ${theme.font.weight.regular};
  line-height: ${theme.typography.subHeadings.mega.lineHeight};
  text-align: center;

  display: none;

  ${theme.media.mega} {
    display: block;

    font-size: ${theme.typography.subHeadings.kilo.fontSize};
  }
`

const textShareStyles = ({ theme }) => css`
  label: content__text-share;

  display: flex;

  align-items: center;
  justify-content: center;

  margin-top: ${theme.spacings.mega};

  color: ${theme.colors.o500};
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  line-height: 14px;

  span {
    margin-left: ${theme.spacings.byte};
  }

  svg {
    display: block;
    width: 12px;
    height: 12px;
  }

  ${theme.media.mega} {
    display: none;
  }
`

const pictureIconStyles = ({ theme }) => css`
  label: content__picture-icon;

  svg {
    position: absolute;

    top: ${theme.spacings.mega};
    right: ${theme.spacings.mega};

    width: 14px;
    height: 14px;

    display: block;
    color: ${theme.colors.n300};
  }
`

export const Picture = styled('div')(pictureStyles)
export const Image = styled('img')(imageStyles)
export const IconDollar = styled('div')(iconDollarStyles)
export const Icon = styled('div')(iconStyles)
export const Symbol = styled('div')(symbolStyles)
export const Title = styled('span')(titleStyles)
export const SubTitle = styled('span')(subTitleStyles)
export const TextShare = styled('span')(textShareStyles)
export const PictureIcon = styled('div')(pictureIconStyles)

const contentActiveStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    label: content--active;

    ${PictureIcon} {
      svg {
        color: ${theme.colors.white};
      }
    }

    ${Title} {
      color: ${theme.colors.white};
    }

    ${Picture} {
      border-color: ${theme.colors.f500};

      svg {
        color: ${theme.colors.white};
      }
    }

    ${Icon} {
      svg {
        fill: ${theme.colors.white};
      }
    }

    ${Symbol} {
      color: ${theme.colors.f300};
      background: ${theme.colors.f500};
    }

    ${TextShare} {
      color: ${theme.colors.f300};
    }
  `

export const Content = styled('div')(contentStyles, contentActiveStyles)
